import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/content";
import { useSeo } from "@/hooks/useSeo";

export default function Terms() {
  useSeo("Terms & Conditions | RD Cleaning Services Perth", "Terms and conditions for using the RD Cleaning Services website, Perth WA.");
  return (
    <>
      <PageHero eyebrow="Legal" title="Terms &amp; Conditions" subtitle="The terms that govern the use of this website and our services." image={IMG.interior} />
      <section className="bg-white py-16 sm:py-24">
        <Reveal className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <div className="space-y-8 text-sm leading-relaxed text-slate-600 sm:text-base">
            <div>
              <h2 className="font-display text-xl font-bold text-navy">General</h2>
              <p className="mt-3">This website is operated by RD Cleaning Services ("we", "us"), a professional cleaning business serving Perth, Western Australia. By using this website you accept these terms.</p>
            </div>
            <div>
              <h2 className="font-display text-xl font-bold text-navy">Quotes &amp; Bookings</h2>
              <p className="mt-3">Submitting an enquiry form does not create a booking. Quotes are provided based on the information supplied and may be adjusted following a discussion or site assessment. Bookings are confirmed directly with our team.</p>
            </div>
            <div>
              <h2 className="font-display text-xl font-bold text-navy">Website Content</h2>
              <p className="mt-3">Content on this website is provided for general information. Service availability may vary by location and scheduling. Testimonial placeholders shown on this site are not genuine customer reviews and will be replaced with real feedback as it is received.</p>
            </div>
            <div>
              <h2 className="font-display text-xl font-bold text-navy">Liability</h2>
              <p className="mt-3">We take care to keep website information accurate, but make no warranties about completeness or availability. Nothing on this website excludes rights you may have under Australian Consumer Law.</p>
            </div>
            <div>
              <h2 className="font-display text-xl font-bold text-navy">Contact</h2>
              <p className="mt-3">Questions about these terms: [EMAIL ADDRESS] or [PHONE NUMBER].</p>
            </div>
            <p className="text-xs text-slate-400">Last updated: July 2026. These terms will be finalised with verified business details before launch.</p>
          </div>
        </Reveal>
      </section>
    </>
  );
}
